<script setup>
import '@/assets/cloudCounter/css/style.css'
import { ref, defineProps, } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'

const goNextPage = () => {
    console.log('Go! Go! Go!');
}

const applicantData = {
    boxList: [
        {
            title: '林中富',
            list: [
                { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險', },
                { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險', }
            ]
        },
    ],
};

//是否以電子文件寄送本次變更批註內容 checkbox
const checkboxAgree = ref(false);

</script>

<template>

    <Layout :header="{ text: '要保人或被保險人姓名變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫內容', '確認資料', '視訊預約',]" :index="2"></Process>
        </div>

        <div class="pb-8 flex justify-between items-center">
            <h2 class="font-bold text-2xl">確認以下已填寫資料</h2>
            <div class=" text-[#0093C1] textsm">
                <router-link :to="{ name:'' }">
                    <svg class="inline-block" fill="#0093C1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <title>square-edit-outline</title>
                        <path
                            d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" />
                    </svg>修改
                </router-link>
            </div>
        </div>

        <div class="pb-6">
            <h3 class="font-bold text-xl pb-2">新要保人姓名</h3>
            <p class="pb-2">同時辦理以下保單號碼之要保人姓名變更</p>
            <CaseBox :caseBox="applicantData"></CaseBox>
        </div>

        <div class="pb-6">
            <h3 class="font-bold text-xl pb-2">新被保險人姓名</h3>
            <p class="pb-2">同時辦理以下保單號碼之被保險人姓名變更</p>
            <CaseBox :caseBox="applicantData"></CaseBox>
        </div>

        <div class="pb-6">
            <h4 class="font-bold text-lg pb-3">是否以電子文件寄送本次變更批註內容</h4>
            <label class="flex">
                <div class="pt-1 pr-3">
                    <input class="w-[20px] h-[20px] " type="checkbox" value="agree" v-model="checkboxAgree">
                </div>
                <p class="flex-1">
                    本人（即要保人）同意本次變更完成後，貴公司將批註內容以電子文件寄送至本次填寫或本人留存於貴公司最近一筆電子郵件信箱；未提供電子郵件信箱或郵件遭退回，則發送簡訊通知，若未留存行動電話或簡訊通知亦遭退回，則貴公司改以紙本寄送予本人。
                </p>
            </label>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped></style>